import { useInfiniteQuery } from 'react-query';
import { ListCashMovementQuery } from './BoxMovement.types';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import { useServiceError } from '@/hooks';
import { listCashMovement } from './BoxMovement.service';

export function useCashMovementList(params?: ListCashMovementQuery) {
  const query = useInfiniteQuery(
    ['cash-movement', { ...params }],
    ({ pageParam }) => {
      const req: ListCashMovementQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listCashMovement(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
      enabled:
        !!params?.companyIds?.length &&
        !!params?.bankAccountIds?.length &&
        !!params?.startDate &&
        !!params?.finalDate,
    },
  );

  useServiceError(query.error);

  return query;
}
